import baseScmService from 'services/baseScmService';

const sbatGroupLessonService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    updateSbatGroupLesson: build.mutation({
      query: ({ sbatGroupId, lesson, classTag }) => ({
        method: 'PUT',
        url: `/sbat-groups/${sbatGroupId}/lessons/${lesson.id}/`,
        body: {
          lesson,
          class_tag: classTag,
        },
      }),
      invalidatesTags: (result, error, { sbatGroupId }) =>
        error ? [] : [{ type: 'SbatGroup', id: sbatGroupId }],
    }),
    createSbatGroupLesson: build.mutation({
      query: ({ sbatGroupId, lesson }) => ({
        method: 'POST',
        url: `/sbat-groups/${sbatGroupId}/lessons/`,
        body: {
          lesson,
        },
      }),
      invalidatesTags: (result, error, { sbatGroupId }) =>
        error ? [] : [{ type: 'SbatGroup', id: sbatGroupId }],
    }),
    deleteSbatGroupLesson: build.mutation({
      query: ({ sbatGroupId, lessonId }) => ({
        method: 'DELETE',
        url: `sbat-groups/${sbatGroupId}/lessons/${lessonId}`,
      }),
      invalidatesTags: (result, error, { sbatGroupId }) =>
        error ? [] : [{ type: 'SbatGroup', id: sbatGroupId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateSbatGroupLessonMutation,
  useDeleteSbatGroupLessonMutation,
  useUpdateSbatGroupLessonMutation,
} = sbatGroupLessonService;

export default sbatGroupLessonService;
